import { useCallback } from 'react';
import type { Permission } from '@pm/shared';
import { useSession } from './session';

/**
 * The UI's only authorization question. It mirrors the API's permission
 * check rather than re-deriving rules, so a button can never appear for an
 * action the server would refuse.
 */
export function usePermissions() {
  const { data: session } = useSession();
  const granted = session?.permissions;

  const can = useCallback(
    (...required: Permission[]) => required.every((p) => granted?.includes(p) ?? false),
    [granted],
  );

  const canAny = useCallback(
    (...required: Permission[]) => required.some((p) => granted?.includes(p) ?? false),
    [granted],
  );

  return {
    can,
    canAny,
    roles: session?.roles ?? [],
    workspaceRole: (workspaceId: string) => session?.workspaceRoles[workspaceId],
    isReady: Boolean(session),
  };
}
